import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const CRASH_COURSES_CONFIG = enabledOn(PlatformSlug.DATBooster, PlatformSlug.OATBooster, PlatformSlug.DATCrusher)

export const isCrashCoursesAvailable = (slug?: PlatformSlug) => isFeatureAvailable(CRASH_COURSES_CONFIG, slug)
